// generated by the plop

export class GetMasters {
  static type = '[masters] GetMasters';

  constructor(public searchText: string) {
  }
}


export class GetAllMasters {
  static type = '[masters] GetAllMasters';
}
